import React from 'react';

import { TableClinical } from '@components/DataTable';
import type { DataTableColumn } from '@components/DataTable/DataTable';
import Icon from '@components/Icon/Icon';

import {
  ClinicalStatusDiv, // SmallCircleClinical,
  // SmallCircleNonClinical,
} from '@views/Records/HealthTracker/Drilldown/Drilldown.style';

export const DATATABLE_COLUMNS: Record<string, DataTableColumn[]> = {
  'sleep-duration': [
    {
      name: 'value',
      style: 'blue-hover',
      title: 'Duration',
      canFilter: false,
    },
    {
      name: 'date',
      title: 'Date',
      style: 'date',
      canFilter: true,
    },
    {
      name: 'source',
      style: 'small-light',
      title: 'Source',
      canFilter: true,
    },
    {
      name: 'clinicalNonClinical',
      title: (
        <ClinicalStatusDiv>
          <Icon color="purple.main" name="circle" type="fas" /> Clinical /
          <Icon color="purple.main" name="circle" type="fat" />
          Non-Clinical
        </ClinicalStatusDiv>
      ),
      canFilter: true,
      render: (value: string) => <TableClinical value={value} />,
    },
  ],
  default: [
    {
      name: 'value',
      style: 'blue-hover',
      title: 'Value',
      canFilter: false,
    },
    {
      name: 'date',
      title: 'Date',
      style: 'date',
      canFilter: true,
    },
    /* eslint-disable multiline-comment-style, capitalized-comments */
    // {
    //   name: 'time',
    //   title: 'Time',
    //   style: 'time',
    //   canFilter: true,
    // },
    {
      name: 'source',
      style: 'small-light',
      title: 'Source',
      canFilter: true,
    },
    {
      name: 'clinicalNonClinical',
      title: (
        <ClinicalStatusDiv>
          <Icon color="purple.main" name="circle" type="fas" /> Clinical /{' '}
          <Icon color="purple.main" name="circle" type="far" />
          Non-Clinical
        </ClinicalStatusDiv>
      ),
      canFilter: true,
      render: (value: string) => <TableClinical value={value} />,
    },
  ],
};
